uniform sampler2D particleTexture;
uniform float opacity;

#pragma glslify: snoise = require('../partials/snoise.glsl')
varying vec3 vColor;
varying float vAlpha;
varying float vRandomValue;

void main() {
    vec2 uv = gl_PointCoord;
    
    float n = snoise(uv * 2.0 + vRandomValue * 0.5);
    float distortion = n * 0.4; 
    
    uv += distortion;

    vec4 textureColor = texture2D(particleTexture, uv);

    if (textureColor.a < 0.1) discard;

    vec3 opaqueColor = textureColor.rgb * textureColor.a;

    gl_FragColor = vec4(vColor * opaqueColor, textureColor.a * vAlpha * opacity); 
}
